import * as actionTypes from "../actionTypes";
import * as actionUrl from "../../../config/actionUrl";
import { convertObjectToArray } from "../../../util/utility";
import axios from "axios";

export const createViomeTestStart = () => {
  return {
    type: actionTypes.CREATE_VIOME_TEST_START
  };
};
export const createViomeTestFail = errorResponse => {
  return {
    type: actionTypes.CREATE_VIOME_TEST_FAIL,
    error: errorResponse.debugMessage
  };
};

export const createViomeTestSuccess = productResponse => {
  return {
    type: actionTypes.CREATE_VIOME_TEST_SUCCESS,
    result: convertObjectToArray(productResponse.response, "testName"),
    message: productResponse.message
  };
};

export const createViomeTest = formData => {
  return dispatch => {
    dispatch(createViomeTestStart());
    axios
      .post(actionUrl.CREATE_VIOME_TEST_URL, formData, {
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        dispatch(createViomeTestSuccess(res.data.ProductResponse));
      })
      .catch(err => {
        dispatch(createViomeTestFail(err.response.data.producterrorresponse));
      });
  };
};

export const updateViomeTestStart = () => {
  return {
    type: actionTypes.UPDATE_VIOME_TEST_START
  };
};

export const updateViomeTestFail = errorResponse => {
  return {
    type: actionTypes.UPDATE_VIOME_TEST_FAIL,
    error: errorResponse.debugMessage
  };
};

export const updateViomeTestSuccess = productResponse => {
  return {
    type: actionTypes.UPDATE_VIOME_TEST_SUCCESS,
    testList: productResponse.response,
    message: productResponse.message
  };
};

export const updateViomeTest = formData => {
  return async dispatch => {
    dispatch(updateViomeTestStart());
    axios
      .post(actionUrl.UPDATE_VIOME_TEST_URL, formData, {
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        withCredentials: true,
      })
      .then(res => {
        dispatch(updateViomeTestSuccess(res.data.ProductResponse));
      })
      .catch(err => {
        dispatch(updateViomeTestFail(err.response.data.producterrorresponse));
      });
  };
};
